import React, {Fragment, useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import { currentLang, recipeURL } from '../../../utils/functions';
import {getRelatedRecipes} from '../../../utils/services';
import flatstore from 'flatstore';
import Image from '../Image';
import {isNil} from 'lodash';
import W from '../Word';

function RelatedRecipes({relatedType, relatedSlug, related_recipes_data}) {
    const [items, setItems] = useState(null);
    const { t } = useTranslation();
    //const url = recipeURL(recipe.slug)
    useEffect(() => {
        related_recipes_data = null;
    }, [])

    useEffect(() => {
        if(isNil(related_recipes_data) && isNil(items)){
            getRelatedRecipes(relatedType, relatedSlug);
        }
        if(related_recipes_data && related_recipes_data.length > 0 && isNil(items)){
            setItems(related_recipes_data);
        }
    }, [related_recipes_data])

    return (
        <section className="pt-70 pb-80 bg--gray-light">
            <div className="mb-40 text--center">
                <h3 className="heading heading--h3 pr-30 pl-30"> <W>recipes.related_recipes_title</W></h3>
            </div>
            <div className="container">
                <div className="row">
                    {items && items.map(recipe=>{
                        //var url = '/'+currentLang()+'/'+t("menu.recipes")+'/'+recipe.slug;
                        var url = recipeURL(recipe.slug);

                        return (
                            <div className="col-xs-12 col-md-6 col-lg-4">
                                <div className="list__item">
                                    <div className="list__body">
                                        <div className="list__image"><a className="read-more" href={url}><Image src={recipe.image_url} /></a>
                                            <div className="list__info">
                                                <div className="badge"></div>
                                            </div>
                                        </div>
                                        <div className="list__description">
                                            <div>
                                                <h3 className="title"> <a className="text--white" href={url}>{recipe.title}</a>
                                                </h3>
                                            </div>
                                            <a className="read-more" href={url}><W>recipes.view_recipe_button</W></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="row mt-20">
                    <div className="col-lg-4"></div>
                    <div className="col-lg-4"> <a href={recipeURL('')} className="btn btn--full btn--red"> <span className="icon-magnify mr-10"></span>
                        <W>recipes.related_recipes_button_text</W></a> </div>
                    <div className="col-lg-4"></div>
                </div>
            </div>
        </section>
    )
}

export default flatstore.connect(['related_recipes_data'])(RelatedRecipes);